import type { State } from "~/services";
import type { StaffBookingRegistration } from "./staff-booking-patient-schema";

export const REGISTRATION_STATUS = {
  REGISTERED: "registered",
  NEW_STATE: "newState",
  NEW_PROVIDER_GROUP: "newProviderGroup",
} as const;

export type RegistrationStatus =
  (typeof REGISTRATION_STATUS)[keyof typeof REGISTRATION_STATUS];

export const getRegistrationStatus = ({
  registrations,
  state,
}: {
  registrations: StaffBookingRegistration[];
  state: State;
}): RegistrationStatus => {
  const hasMissingStateIds = registrations.some(
    (registration) => !registration.stateIds,
  );

  if (!registrations.length || !state.providerGroup || hasMissingStateIds) {
    return REGISTRATION_STATUS.REGISTERED;
  }

  const isRegisteredInState = registrations.some((registration) =>
    registration.stateIds?.includes(state.id),
  );

  if (isRegisteredInState) return REGISTRATION_STATUS.REGISTERED;

  const isRegisteredInProviderGroup = registrations.some(
    (registration) => registration.providerGroup.id === state.providerGroup?.id,
  );

  return isRegisteredInProviderGroup
    ? REGISTRATION_STATUS.NEW_STATE
    : REGISTRATION_STATUS.NEW_PROVIDER_GROUP;
};
